var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
import { Color } from '@atomic/obj.constants';
export var FocusCss = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  outline: 2px dashed ", ";\n  outline-offset: 2px;\n"], ["\n  outline: 2px dashed ", ";\n  outline-offset: 2px;\n"])), Color.Black);
var templateObject_1;
